angular.module('galilai.creator').controller('PlansController', function($timeout, experiments, $scope, api, $location, $rootScope) {

    console.log('PlansController')

    $scope.allPlansSpec = []
    $scope.plansSpec = []
    $scope.basePlansSpec = []

    $scope.plansMapping = {}
    $scope.activeAccounts = []
    $scope.selection = {
        type: (experiments.isVariant('plans-period-monthly') || $rootScope.IAPEnabled()) ? 'monthly' : 'annual',
        quantity: 1,
        plan: null,
        loginForm: {
            email: '',
        }
    }

    $scope.loading = false
    $scope.plansMode = 'upgrade'
    $scope.email = null
    $scope.view = {
        currentPlan: null,
        disabled: {},
        emailForm: false
    }
    $scope.inputs = {}
    let BASE_FILTERS = [
        {
            id: 'monthly',
            name: gettext('plan.filter.monthly'),
        },
        {
            id: 'annual',
            name: gettext('plan.filter.annual'),
        },
    ]

    $scope.filters = BASE_FILTERS

    $scope.featuresAll = [
    ]

    $scope.featuresPerPlan = {
        'products': ['shop', 'ads']
    }

    // Features que só aparecem quando o modal foi aberto por uma origem específica.
    // O bônus em compra de créditos só faz sentido para quem veio do modal de crédito
    // clicando em "Mude de plano para aumentar seu bônus"; nos outros contextos polui
    // a lista sem ajudar a decidir o plano.
    const FEATURES_PER_SOURCE = {
        'bonus_credits': ['credits_bonus'],
    }

    const baseCreditsExample = 100
    $scope.featuresMap = {
        [_PLANS.BASIC]: {
            'unlimited_posts': true,
            'included_designs': true,
            'bonus_credits': true,
            'integrated_publishing': false,
            'reels': false,
            'audio': false,
            'custom_videos': false,
            'products': 0,
        },
        [_PLANS.PLUS]: {
            'unlimited_posts': true,
            'included_designs': true,
            'bonus_credits': true,
            'integrated_publishing': true,
            'reels': false,
            'audio': false,
            'custom_videos': false,
            'products': 0,
        },
        [_PLANS.PRO]: {
            'unlimited_posts': true,
            'included_designs': true,
            'bonus_credits': true,
            'integrated_publishing': true,
            'reels': true,
            'audio': false,
            'custom_videos': false,
            'products': 5,
        },
        [_PLANS.MAX]: {
            'unlimited_posts': true,
            'included_designs': true,
            'bonus_credits': true,
            'integrated_publishing': true,
            'reels': true,
            'audio': true,
            'custom_videos': true,
            'products': 10,
        },
        [_PLANS.SHOP]: {
            'unlimited_posts': true,
            'integrated_publishing': true,
            'reels': true,
            'audio': true,
            'custom_videos': true,
            'products': 'infinite',
        },
        [_PLANS.INFINITE]: {
            'unlimited_posts': true,
            'integrated_publishing': true,
            'reels': true,
        },
    }
    const DISABLE_PER_SOURCE = {
        'Publish Post Directly': [_PLANS.BASIC ],
        'Publish Reels': [_PLANS.BASIC],
        // Video generation needs the same plans that can publish an mp4
        'video_generation': [_PLANS.BASIC],
    }

    const HAS_SIDE_NOTE = ['unlimited_posts']

    $scope.extraMessage = ''
    $rootScope.$on('plansSource', function(event, source) {
        $scope.activeAccounts = []
        $scope.view.source = source
        let key = 'source.' + source
        let value = gettext(key);
        if (value !== key) {
            $scope.extraMessage = value
        } else {
            $scope.extraMessage = null
        }
        $scope.view.disabled = {}
        if (DISABLE_PER_SOURCE[source]) {
            for (plan of DISABLE_PER_SOURCE[source]) {
                $scope.view.disabled[plan] = true
            }
        }

        if (source == 'Add more products') {
            $scope.buildShopPlans()
        } else {
            $scope.buildBasePlans()
        }

        $scope.view.showAlert = source == 'Publish Reels' || source == 'Max projects reached'
        $scope.view.showButtonAfterQuantity = source == 'Max projects reached'
        $scope.view.availabilityMessage = null
        if (source == 'Max projects reached') {
            $scope.view.customHeaderMessage = gettext('label.need_to_increase_quantity')
        } else {
            $scope.view.customHeaderMessage = null
        }
        const availabilityMap = {
            'Publish Reels': [getPlansName(_PLANS.PRO), getPlansName(_PLANS.MAX)],
        }
        if (availabilityMap[source]) {
            $scope.view.availabilityMessage = availabilityMap[source].join(', ')
        }

        $scope.filters = $rootScope.IAPEnabled() ? [] : BASE_FILTERS
        if ($rootScope.IAPEnabled()) {
            getOfferings()
        }
        // TODO - Maybe we should remove the check
        if (IS_APP) {
            $scope.plansMode = isLoggedIn() ? 'upgrade' : 'trial'
        }

        // Get existing customer
        $rootScope.$emit('getCurrentHandle', { source: 'plans' })
    })

    $rootScope.$on('onCurrentHandle', function(event, data) {
        if (data && data.handle) {
            api.checkExistingCustomerByHandle(data.handle).then(function(res) {
                $scope.activeAccounts = res.data.activeAccounts || []
            }).catch(function(err) {
            }).finally(function() {
                $timeout(angular.noop)
            })
        }
    })

    $scope.showIAPMessage = function() {
        return $rootScope.IAPEnabled()
    }

    $scope.getIAPMessage = function() {
        return gettext('label.iap_info_' + CURRENT_OS)
    }

    async function getOfferings() {
        let response = await sendMessageWithCallback({
            name: 'getOfferings',
        })
        $scope.plansSpec = response.result
        $timeout(() => {
            $scope.buildPlansMapping()
            $scope.buildPlans()
        })
    }

    $rootScope.$on('onUserData', function(event, userData) {
        if (userData && userData.billing && userData.billing.customer) {
            $scope.view.currentPlan = userData.plan
        } else {
            $scope.view.currentPlan = null
        }
        let activeQuantity = Math.min(userData.usage.projects || 1, userData.plan.quantity || 1)
        activeQuantity = activeQuantity || 1
        if (activeQuantity < 1 || isNaN(activeQuantity)) {
            activeQuantity = 1
        }

        $scope.selection.type = userData.plan.period || 'monthly'
        $scope.selection.quantity = activeQuantity
        $scope.selection.plan = userData.plan.id

        $scope.inputs[userData.plan.id] = activeQuantity

        $scope.buildPlans()
        $scope.updateAllPlansQuantity($scope.inputs[userData.plan.id])
        $scope.buildFeatures()
        $timeout(angular.noop)
    })

    // Listen for onGoogleAuth
    window.addEventListener('message', function(event) {
        if (event.data.type === 'onGoogleAuth' && event.data.source === 'upgrade') {
            $timeout(() => {
                $scope.credentials = event.data.credentials
                if (event.data.decoded && event.data.decoded.email) {
                    $scope.email = event.data.decoded.email
                }

                $scope.startPlanWithEmail()
            })
        }
    })

    $scope.isCurrentPlan = function(plan) {
        return $scope.view.currentPlan && plan.id == $scope.view.currentPlan.id && $scope.view.currentPlan.period == $scope.selection.type
    }

    $scope.isDisabled = function(plan) {
        return $scope.view.disabled[plan.id]
    }

    $scope.buildFeatures = function() {
        let features = {}
        let plans = Object.keys($scope.featuresMap)

        // Include features all followed by features mapp
        for (feature of $scope.featuresAll) {
            for (plan of plans) {
                if (!features[plan]) {
                    features[plan] = []
                }
                features[plan].push({
                    'id': feature,
                    'name': gettext('features.' + feature),
                    'active': true,
                    'has_note': HAS_SIDE_NOTE.includes(feature),
                })
            }
        }
        let availablePlans = $scope.plansSpec.map(plan => plan.id)
        let ignoreFeatures = []

        for (let ignoreFeature in $scope.featuresPerPlan) {
            let onlyInPlans = $scope.featuresPerPlan[ignoreFeature]
            if (!onlyInPlans.some(plan => availablePlans.includes(plan))) {
                ignoreFeatures.push(ignoreFeature)
            }
        }

        for (plan of plans) {
            if (!features[plan]) {
                features[plan] = []
            }
            for (feature of Object.keys($scope.featuresMap[plan])) {
                if (ignoreFeatures.includes(feature)) {
                    continue
                }
                // Feature restrita a certas origens: sem origem compatível, nem entra na lista.
                if (FEATURES_PER_SOURCE[feature] && !FEATURES_PER_SOURCE[feature].includes($scope.view.source)) {
                    continue
                }
                let featureName = gettext('features.' + feature)
                if (feature == 'included_designs') {
                    // Cota mensal inclusa. Varia com o período selecionado (anual inclui
                    // mais), por isso é lida de $scope.plans, que buildPlans() já filtrou
                    // pelo período corrente.
                    //
                    // O número é aproximado de propósito: o crédito é debitado por imagem
                    // gerada, então carrossel de várias páginas e reedições consomem mais
                    // de um. Daí o "~" no texto.
                    let planOption = $scope.plans.find(p => p.id == plan)
                    let includedDesigns = planOption?.includedDesigns || 0
                    if (!includedDesigns) {
                        continue
                    }
                    featureName = gettext('features.included_designs').replace('$VAR', includedDesigns)
                    featureName += '<br><small class="text-muted">(' +
                        gettext('features.included_credits').replace('$VAR', planOption.includedCredits) +
                        ')</small>'
                }
                if (feature == 'bonus_credits') {
                    let multiplierValue = $scope.plans.find(p => p.id == plan && p.multiplier)?.multiplier || 1
                    let multiplierInPercent = Math.round((multiplierValue - 1) * 100)

                    if (multiplierValue == 2) {
                        featureName = gettext('features.bonus_credits_double')
                    } else if (multiplierValue == 3) {
                        featureName = gettext('features.bonus_credits_triple')
                    } else {
                        featureName = gettext('features.bonus_credits').replace('$VAR', multiplierInPercent)
                    }
                    featureName += '<br><small class="text-muted">(' +
                        gettext('features.bonus_credits_example')
                            .replace('$VAR1', baseCreditsExample)
                            .replace('$VAR2', parseInt((multiplierValue-1) * baseCreditsExample)) +
                        ')</small>'
                }
                features[plan].push({
                    'id': feature,
                    'name': featureName,
                    'active': $scope.featuresMap[plan][feature],
                    'has_note': HAS_SIDE_NOTE.includes(feature),
                })
            }
        }
        $scope.features = features
    }

    $scope.buildBasePlans = function() {
        $scope.plansSpec = $scope.allPlansSpec.filter(plan => plan.id != _PLANS.INFINITE && plan.id != _PLANS.PLUS && plan.id != _PLANS.SHOP && plan.id != _PLANS.ADS)
        $scope.basePlansSpec = JSON.parse(JSON.stringify($scope.plansSpec))
        $scope.buildPlansMapping()
        $scope.buildPlans()
        $scope.buildFeatures()
    }

    $scope.buildShopPlans = function() {
        $scope.plansSpec = $scope.allPlansSpec.filter(plan => plan.id == _PLANS.SHOP || plan.id == _PLANS.ADS || plan.id == _PLANS.MAX || plan.id == _PLANS.PRO)
        $scope.basePlansSpec = JSON.parse(JSON.stringify($scope.plansSpec))
        $scope.buildPlansMapping()
        $scope.buildPlans()
        $scope.buildFeatures()
    }

    $scope.init = function() {
        api.getPlans({
            include: 'shop,ads'
        }).then(function(res) {
            $scope.allPlansSpec = res.data
            $scope.buildBasePlans()
        })
        .catch(function() {
            // TASK - No handling
        })
        if (!isLoggedIn()) {
            $scope.plansMode = 'trial'
        }
        if (isLoggedIn()) {
            api.config({}).then(function(res) {
                $rootScope.$emit('onUserData', res.data)
            })
            .catch(function(err) {
                console.log(err)
            })
        }
    }

    $scope.selectCurrentType = function(filter) {
        $scope.selection.type = filter.id
        $scope.buildPlans()

        let params = {
            plan: plan.id,
            period: $scope.selection.type,
            quantity: $scope.inputs[plan.id],
        }
        track('Editor Plans Select Period', params)

        $scope.buildFeatures()
    }

    function calculatePriceTotalFee(plan) {
        if (!Array.isArray(plan.structure.per_unit)) {
            return plan.structure.flat
        }

        let totalFee = plan.structure.flat
        let totalQuantity = $scope.inputs[plan.id] || 1

        for (tier of plan.structure.per_unit) {
            const tierFrom = tier.from; // Lower bound of the tier
            const tierTo = tier.to === 'infinity' ? Infinity : tier.to; // Handle 'infinity' as Infinity
            const tierPrice = tier.price;

            // Calculate the quantity of units in this tier
            const unitsInTier = Math.min(tierTo, totalQuantity) - Math.max(tierFrom, 0) + 1
            if (unitsInTier > 0) {
                // Calculate the fee for units in this tier and add it to the total fee
                totalFee += unitsInTier * tierPrice;
            }
        }

        return totalFee
    }
    $scope.calculatePrice = function(plan) {
        let totalFee = calculatePriceTotalFee(plan)
        if ($scope.selection.type == 'annual') {
            totalFee = totalFee/12
        }
        let round = Math.round(totalFee * 100) / 100
        if (plan.structure.currency == 'R$') {
            // TASK [HP] Improve this
            round = round.toFixed(2).toString().replace(',', '___').replace('.', ',').replace('___', '.')
        }
        return round
    }

    $scope.calculateDiscount = function(plan) {
        if ($scope.selection.type != 'annual') {
            return null
        }
        let monthlyPlan = $scope.plansMapping[plan.id]['monthly']
        let calculateMontlyFee = calculatePriceTotalFee({
            structure: monthlyPlan.structure,
            id: monthlyPlan.id,
        })
        let calculatedAnnualFee = calculatePriceTotalFee(plan)
        let discount = 100 - ((calculatedAnnualFee/12) / (calculateMontlyFee) * 100)
        return Math.round(discount)
    }

    $scope.updateAllPlansQuantity = function(quantity) {
        let allPlans = [
            _PLANS.BASIC,
            _PLANS.PLUS,
            _PLANS.PRO,
            _PLANS.MAX,
            _PLANS.SHOP,
            _PLANS.ADS,
            _PLANS.INFINITE,
        ]
        for (plan of allPlans) {
            $scope.inputs[plan] = quantity
        }
    }
    $scope.onQuantityChange = function(plan) {
        let minPlan = plan.structure.min_unit || 1
        if ($scope.inputs[plan.id] < minPlan) {
            $scope.inputs[plan.id] = minPlan
        }
        if (isNaN($scope.inputs[plan.id])) {
            $scope.inputs[plan.id] = minPlan
        }
        $scope.updateAllPlansQuantity($scope.inputs[plan.id])
    }
    $scope.decrementQuantity = function(plan) {
        let minPlan = plan.structure.min_unit || 1
        if ($scope.inputs[plan.id] > minPlan) {
            $scope.inputs[plan.id] -= 1
        }

        let params = {
            plan: plan.id,
            period: $scope.selection.type,
            quantity: $scope.inputs[plan.id],
        }
        $scope.updateAllPlansQuantity($scope.inputs[plan.id])
        track('Editor Plans Decrement', params)
    }

    $scope.incrementQuantity = function(plan) {
        if ($rootScope.IAPEnabled()) {
            showConfirm(gettext('label.feature_contact_support'), null, function(status) {
                if (status) {
                    let contactURL = _trans.support.url[language]
                    // TODO - test here
                    window.open(contactURL, '_system')
                }
            })
            return
        }
        $scope.inputs[plan.id] += 1

        let params = {
            plan: plan.id,
            period: $scope.selection.type,
            quantity: $scope.inputs[plan.id],
        }
        $scope.updateAllPlansQuantity($scope.inputs[plan.id])
        track('Editor Plans Increment', params)
    }

    $scope.buildPlansMapping = function() {
        for (plan of $scope.plansSpec) {
            for (option of plan.options) {
                if (!$scope.plansMapping[plan.id]) {
                    $scope.plansMapping[plan.id] = {}
                }
                $scope.plansMapping[plan.id][option.type] = JSON.parse(JSON.stringify(option))
                $scope.plansMapping[plan.id][option.type].id = plan.id
            }
        }
    }

    $scope.buildPlans = function() {
        let plans = []
        for (plan of $scope.plansSpec) {
            for (option of plan.options) {
                if (option.type != $scope.selection.type) {
                    continue
                }
                let inputQuantity = 1
                if ($scope.inputs[plan.id]) {
                    inputQuantity = $scope.inputs[plan.id]
                }
                if (!$scope.inputs[plan.id]) {
                    if (option.structure.min_unit && parseInt(option.structure.min_unit) > 1) {
                        $scope.inputs[plan.id] = option.structure.min_unit
                    } else {
                        $scope.inputs[plan.id] = 1
                    }
                }
                let messageAmount = null
                if (option.structure.min_unit == 'infinity') {
                    messageAmount = gettext('features.unlimited_accounts')
                } else if (!option.structure.min_unit || option.structure.min_unit == 1 && !option.structure.per_unit) {
                    messageAmount = gettext('features.1_account')
                } else {
                    messageAmount = gettext('features.accounts')
                }
                let optionPlan = {
                    id: plan.id,
                    name: option.plan,
                    discount: 10,
                    multiplier: option.multiplier || 1,
                    includedDesigns: option.includedDesigns || 0,
                    includedCredits: option.includedCredits || 0,
                    currency: option.structure.currency,
                    structure: option.structure,
                    quantity: inputQuantity,
                    allowChange: !!option.structure.per_unit,
                    messageAmount: messageAmount,
                }
                plans.push(optionPlan)
            }
        }
        $scope.plans = plans
        $timeout(angular.noop)
    }

    $scope.choosePlan = function(plan) {
        $scope.loading = true

        let params = {
            plan: plan.id,
            quantity: $scope.inputs[plan.id],
            period: $scope.selection.type,
        }

        let coupon = null
        try {
            coupon = localStorage.getItem('galilai.coupon')
        } catch (e) {
        }

        track('Editor Plans Choose', params)
        let planInput = {
            planId: plan.id,
            period: $scope.selection.type,
            quantity: $scope.inputs[plan.id],
            mode: $scope.plansMode,
            cancelURL: $location.absUrl(),
            coupon: coupon,
            tempId: $rootScope.userTempID,
        }

        if ($scope.plansMode == 'trial') {
            planInput.loginForm = getUserLoginForm($scope.email)
            if ($scope.credentials) {
                try {
                    planInput.loginForm.meta.google = $scope.credentials
                } catch (e) {
                    console.log(e)
                }
            }
        }
        try {
            identifyUserData($scope.email)
        } catch (e) {}
        // TODO add login form
        api.upgradePlan(planInput).then(function(res) {
            let data = res.data
            if (data && data.token) {
                localStorage.setItem('auth.token', data.token)
            }
            try {
                if (data && data.user && data.user._id) {
                    identifyUserWithId(data.user._id)
                }
            } catch (e) {}

            // Flow without asking for payment
            if (data && data.updated_plan) {
                if ($rootScope.hideUpgrade) {
                    $rootScope.hideUpgrade()
                }
                showSuccess(gettext('plan.upgraded'), null, function() {
                    if (data.token) {
                        localStorage.setItem('auth.token', data.token)
                    }
                    if (data.url) {
                        $rootScope.startCheckout(data, params)
                    } else {
                        reloadLocation(true)
                    }
                })
                return
            }
            if (data && data.already_customer) {
                if (data.token) {
                    console.log('[Customer]', data)
                    localStorage.setItem('auth.token', data.token)
                    setTimeout(function() {
                        if (data.url) {
                            $rootScope.startCheckout(data, params)
                        } else {
                            reloadLocation(true)
                        }
                    }, 500)
                    return
                }
                $scope.loading = false
                if ($rootScope.hideUpgrade) {
                    $rootScope.hideUpgrade()
                }
                showLoginModal(function() {
                    if (data.url) {
                        $rootScope.startCheckout(data, params)
                    } else {
                        reloadLocation(true)
                    }
                }, true, {
                    email: $scope.email
                }, autoSubmit=true)
                return
            }

            // Tracking
            if ($scope.plansMode == 'trial') {
                // Track trial start open
                track('Editor Trial Open')
            }
            track('Editor Plans Choose Open', params)

            $timeout(() => {
                if (data.url) {
                   $rootScope.startCheckout(data, params)
                }
                $scope.loading = false
            }, 200)

            // Trial Signup
            if (!isLoggedIn()) {
                track('Editor Signup')
            }
            gtag('set', 'user_data', {
                "email": $scope.email
            });
        })
        .catch(function(err) {
            console.log(err)
            showError(gettext('error.upgrade_plan'))
            $timeout(() => {
                $scope.loading = false
            })
        })
    }

    $scope.hideEmailForm = function() {
        $scope.view.emailForm = false
        track('Editor Plans Email Cancel', {
            plan: $scope.selection.plan.id,
            period: $scope.selection.type,
            quantity: $scope.inputs[$scope.selection.plan.id],
        })
    }

    $scope.showEmailForm = function(plan) {
        $scope.view.emailForm = true
        $scope.selection.plan = plan
        track('Editor Plans Email Open', {
            plan: plan.id,
            period: $scope.selection.type,
            quantity: $scope.inputs[plan.id],
        })
    }

    $scope.startPlanWithEmail = function() {
        if (!$scope.email || $scope.email.length < 3) {
            showError(gettext('error.validation.email'))
            return
        }
        try {
            improvedEmail = fixCommonEmailTypos($scope.email);
            if (improvedEmail) {
                $scope.email = improvedEmail;
            }
        } catch (e) {
            console.log(e)
        }
        $scope.choosePlan($scope.selection.plan)
    }

    $scope.handleKeyPressEmail = function($evt) {
        if ($evt.keyCode === 13) {
            $scope.startPlanWithEmail()
        }
    }

    $scope.showDesignKindExplainModal = function() {
        angular.element('#design-kind-explain-modal').modal('show')
    }
})

angular.module('galilai.creator').controller('FeatureController', function($scope, $rootScope, experiments) {

    $scope.state = {
        plan: {
            upgrade: true,
            waitForPlan: false
        }
    }

    $scope.startUpgrade = function() {
        $scope.state.plan.upgrade = false
        $scope.state.plan.waitForPlan = true
        track('Editor Plan Upgrade', {
            plan: $scope.upgrade.plan,
            price: $scope.upgrade.price,
        })
    }

    $scope.cancelUpgrade = function() {
        $scope.state.plan.upgrade = false
        $scope.state.plan.waitForPlan = false
        // Close modal
        angular.element('#features-modal').modal('hide')
        track('Editor Plan Upgrade Cancel', {
            plan: $scope.upgrade.plan,
            price: $scope.upgrade.price,
        })
    }

    $scope.closeWaitPlan = function() {
        $scope.state.plan.waitForPlan = false
        $scope.state.plan.upgrade = false
        // Close modal
        angular.element('#features-modal').modal('hide')
    }

    $rootScope.$on('showFeatureUpgrade', function(event, data) {
        if (language != 'pt') {
            return
        }
        $scope.state.plan.upgrade = true
        $scope.state.plan.waitForPlan = false

        $scope.upgrade = null
        if (!$scope.upgrade) {
            return
        }
        angular.element('#features-modal').modal('show')
    })
})